import useRedirectToHome from '@/src/hooks/navigation/useRedirectToHome'
import { EventBusyRounded, WarningAmberRounded } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

const SrpErrorState = ({ pastDateError, errorStatus = 500 }: { pastDateError: boolean; errorStatus: number }) => {
    const t = useTranslations('srpErrorState')
    const commonT = useTranslations('common')
    const goToHome = useRedirectToHome()
    const is404Error = errorStatus === 404
    const is400SeriesNon404Error = errorStatus >= 400 && errorStatus < 500 && !is404Error

    const handleBackToHome = () => {
        goToHome({ isReloadRequired: false })
    }

    const handleSearchAgain = () => {
        window.location.reload()
    }
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '85vh',
                textAlign: 'center',
                p: 3,
                bgcolor: 'background.default',
                borderRadius: 2
            }}
        >
            <Box
                sx={{
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    bgcolor: 'error.light',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 3,
                    fontSize: 32
                }}
            >
                {pastDateError ? (
                    <EventBusyRounded fontSize={'inherit'} color="error" />
                ) : (
                    <WarningAmberRounded fontSize={'inherit'} color="error" />
                )}
            </Box>

            <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                {pastDateError
                    ? t('dateInPast')
                    : errorStatus >= 500
                        ? t('serverStumpedPrimary500')
                        : is404Error
                            ? t('serverStumpedPrimary404')
                            : is400SeriesNon404Error ? t('serverStumpedPrimary400')
                                : t('serverStumpedPrimary500')}
            </Typography>

            {!pastDateError && (
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                        maxWidth: '400px',
                        mb: 3,
                        lineHeight: 1.6
                    }}
                >
                    {errorStatus >= 500
                        ? t('serverStumpedSecondary500')
                        : is404Error
                            ? t('serverStumpedSecondary404')
                            : t('serverStumpedSecondary400')}
                </Typography>
            )}

            <Button
                // fullWidth
                variant="customVariantPrimary"
                color="primary"
                sx={{
                    px: 4,
                    py: 1.5,
                    // borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    mt: 2
                }}
                onClick={pastDateError || is400SeriesNon404Error ? handleBackToHome : handleSearchAgain}
            >
                {pastDateError || is400SeriesNon404Error ? commonT('backToHome') : commonT('searchAgain')}
            </Button>
        </Box>
    )
}

export default SrpErrorState
